export const materialParams = [
    {
        id: '5f1058132ba72fb0d87ed31e',
        identifier: 'identifier',
        label: 'Identifier',
        dataType: 'String',
        optional: false
    },
    {
        id: '5f1058132ba72fb0d87ed31e',
        identifier: 'label',
        label: 'Label',
        dataType: 'String',
        optional: false
    },
    {
        id: '5f1058132ba72fb0d87ed31e',
        identifier: 'dataType',
        label: 'DataType',
        dataType: 'String',
        optional: false
    },
    {
        id: '5f1058132ba72fb0d87ed31e',
        identifier: 'optional',
        label: 'Optional',
        dataType: 'String',
        optional: false
    },
    {
        id: '5f1058132ba72fb0d87ed31e',
        identifier: 'filter',
        label: 'Enable for reports filtering',
        dataType: 'Boolean',
        optional: false
    }
];

